import {
  FormField,
  FormItem,
  FormMessage,
} from "ui/components/form";
import { Form } from "react-crud-form";
import { FormLabel } from "components/form";
import { useForm } from "react-hook-form";
import React from "react";
import { useParams } from "react-router-dom";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "ui/components/sheet";
import { Button } from "ui/components/button";
import SelectType from "components/select/type"
import { Textarea } from "ui/components/textarea";
import { useCreateOutcome } from "../create/mutation";
import { useUpdateOutcome } from "../update/mutation";
import { fetchDataOutcomesforForm } from "./read";
import { eventBus } from "utils/eventBus";

export default function CreateOutcomeDialog({
  open,
  onOpenChange,
}) {
  const { casestudyId, itemId } = useParams();
  const createMutation = useCreateOutcome();
  const updateMutation = useUpdateOutcome({ casestudyId });

  const form = useForm({
    defaultValues: {
      type: undefined,
      description: "",
    },
  });

  async function handleCreate(context) {
    const values = context.values;
    const response = await createMutation.mutateAsync({
      item: {
        ...values,
        case_study: casestudyId,
      },
    });
    onOpenChange(false);
    eventBus.emit("refresh:list", `outcomesoutcomes${casestudyId}`);
    form.reset();
  }

  async function handleRead(id) {
    return await fetchDataOutcomesforForm({ id });
  }

  async function handleUpdate(id, context) {
    const values = context?.dirtyValues ?? context?.values ?? {};
    const response = await updateMutation.mutateAsync({
      id,
      item: {
        ...values,
        case_study: casestudyId,
      },
    });
    eventBus.emit("refresh:list", `outcomesoutcomes${casestudyId}`);
    onOpenChange(false);
    return response;
  }

  return (
    <Sheet open={open} onOpenChange={onOpenChange} >
      <SheetContent>
        <SheetHeader>
          <SheetTitle>{itemId === "+" ? "Create" : "Edit"}</SheetTitle>
        </SheetHeader>
        <Form
          form={form}
          create={handleCreate}
          read={handleRead}
          update={handleUpdate}
          itemId={itemId}
        >
          {({ isCreating, createItem, isDirty, isNewItem, updateItem, isUpdating }) => (
            <div className="grid gap-4 overflow-y-auto max-h-[calc(100vh-120px)]">

              {/* Type */}
              <div className="px-4">
                <FormField
                  control={form.control}
                  name="type"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Type</FormLabel>
                      <SelectType
                        collection="outcomes"
                        onValueChange={val => field.onChange(val)}
                        {...field}
                      />
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </div>

              {/* Description */}
              <div className="px-4">
                <FormField
                  control={form.control}
                  name="description"
                  render={({ field }) => {
                    return (
                      <FormItem>
                        <FormLabel>
                          Description
                        </FormLabel>
                        <Textarea {...field} className="min-h-32" />
                        <FormMessage />
                      </FormItem>
                    );
                  }}
                />
              </div>

              <div className="flex justify-end px-4">
                <Button
                  type="button"
                  onClick={() => (isNewItem ? createItem() : updateItem())}
                  disabled={!isDirty || isCreating || isUpdating}
                  loading={isCreating || isUpdating}
                >
                  Save
                </Button>
              </div>
            </div>
          )}
        </Form>
      </SheetContent>
    </Sheet>
  );
}